export default "__VITE_ASSET__CQsWdw0n__"